<template>
  <header>
    <div class="container flex flex_center flex_between">
      <router-link to="/" class="logo"><img src="@/assets/logo@2x.png" alt=""></router-link>
      <nav class="btn-group flex flex_center flex_around">
        <div class="nav_item" :class="{'active':$route.name==='home'}"><router-link to="/">首页</router-link></div>
        <div class="nav_item"  :class="{'active':$route.name==='projects'}">
          <router-link to="/projects/0">重点课题项目</router-link> <span class="iconfont arrow_bottom">&#xe609;</span>
          <ul class="dropdown-menu first-dropdown-menu">
            <li><router-link to="/projects/1">信用立法研究</router-link><router-link to="/projects/2">信用经济研究与顶层设计</router-link></li>
            <li><router-link to="/projects/3">以信用建设优化营商环境</router-link><router-link to="/projects/4">信用管理师培训</router-link></li>
            <li><router-link to="/projects/5">协会创新服务方向与路径</router-link><router-link to="/projects/6">信用示范创建咨询与辅导</router-link></li>
            <li><router-link to="/projects/7">数字治理机制与路径</router-link><router-link to="/projects/8">信用评价与预警模型研发</router-link></li>
            <li><router-link to="/projects/9">政务诚信与政府公信力</router-link><router-link to="/projects/10">街道乡村信用服务与治理</router-link></li>
            <li><router-link to="/projects/11">企业全流程信用管理方案</router-link><router-link to="/projects/12">信用监管制度与应用</router-link></li>
            <li><router-link to="/projects/13">信用仲裁与调解机制构建</router-link><router-link to="/projects/14">“信易+”场景设计</router-link></li>
            <li><router-link to="/projects/15">地方产业信用管理与服务</router-link><router-link to="/projects/16">企业公信力与社会责任</router-link></li>
          </ul>
        </div>

        <div class="nav_item" :class="{'active':$route.name==='xinyongtest'}"><router-link to="/xinyongtest">三维信用体检</router-link></div>
        <div class="nav_item"  :class="{'active':$route.name==='zhengxinfu'}">
          <router-link to="/zhengxinfu/0">文案与咨询</router-link> <span class="iconfont arrow_bottom">&#xe609;</span>
          <ul class="dropdown-menu">
            <li><router-link to="/zhengxinfu/1">信用规划编制</router-link></li>
            <li><router-link to="/zhengxinfu/2">信用政策文件起草</router-link></li>
            <li><router-link to="/zhengxinfu/3">权威专家咨询辅导</router-link></li>
            <li><router-link to="/zhengxinfu/4">信用创新模式打造</router-link></li>
            <li><router-link to="/zhengxinfu/5">清单式管理机制构建</router-link></li>
            <li><router-link to="/zhengxinfu/6">项目建设路径研究</router-link></li>
          </ul>
        </div>
        <div class="nav_item" :class="{'active':$route.name==='module'}">
          <router-link to="/module?id=7&text=三维信用诊断系统">模块产品</router-link> <span class="iconfont arrow_bottom">&#xe609;</span>
          <ul class="dropdown-menu">
            <li><router-link to="/module?id=7&text=三维信用诊断系统">三维信用诊断系统</router-link></li>
            <li><router-link to="/module?id=8&text=企业信管家">信管家-企业信用管理模块</router-link></li>
            <li><router-link to="/module?id=9&text=信用监管套餐">信用监管套餐</router-link></li>
            <li><router-link to="/module?id=10&text=信用档案系统">信用档案系统</router-link></li>
            <li><router-link to="/module?id=11&text=信用预警机">信用预警机</router-link></li>
            <!--<li><router-link to="/module">履约宝-合同履约管理模块</router-link></li>-->
          </ul>
        </div>
        <!--<div class="nav_item" :class="{'active':$route.name==='xinyonghuan'}">信用换</div>
        <div class="nav_item" :class="{'active':$route.name==='xinyongbao'}">基层信用宝</div>
        <div class="nav_item" :class="{'active':$route.name==='xinyuntong'}">行业信云通</div>-->
      </nav>
      <button class="contact_us" @click="toBottom">联系我们</button>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  mounted(){
    document.documentElement.scrollTop = 0;
  },
  methods:{
    toBottom(){
      // 滚动内容的坐标位置0,50000：
      window.scrollTo(0,50000);
    }
  }
};
</script>

<style scoped lang="less">
  header {
    height: 60px;
    background: #005293;

    .logo {
      img{
        display: block;
        width: 90px;
      }
    }

    nav {
      width: 670px;
      .nav_item {
        color: #fff;
        font-size: 16px;
        position: relative;
        line-height: 60px;
        a{
          color: #fff;
        }
        &.active::after {
          content: " ";
          display: block;
          width: 100%;
          height: 2px;
          background: #fff;
          position: absolute;
          left: 0;
          bottom: 14px;
        }

        .iconfont {
          display: inline-block;
          font-size: 12px;
          transition: All 0.3s ease-in-out;
          -webkit-transition: All 0.3s ease-in-out;
          -moz-transition: All 0.3s ease-in-out;
          -o-transition: All 0.3s ease-in-out;
        }

        &:hover .iconfont {
          transform: rotate(180deg);
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          -o-transform: rotate(180deg);
          -ms-transform: rotate(180deg);
        }

        .dropdown-menu {
          position: absolute;
          left: -35px;
          top: 58px;
          z-index: 1000;
          height: 0;
          min-width: 160px;
          margin: 2px 0 0;
          font-size: 14px;
          text-align: left;
          list-style: none;
          -webkit-background-clip: padding-box;
          background-clip: padding-box;
          border-radius: 4px;
          -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
          box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
          background: #fff url("../assets/dropdown-menu-bg.jpg") 100% 100% no-repeat;
          background-size: 150px;
          padding: 0;
          overflow: hidden;
          transition: All 0.2s ease-in-out;
          -webkit-transition: All 0.2s ease-in-out;
          -moz-transition: All 0.2s ease-in-out;
          -o-transition: All 0.2s ease-in-out;
          li > a {
            display: block;
            clear: both;
            font-weight: 400;
            line-height: 1.42857143;
            white-space: nowrap;
            padding: 8px 35px;
            color: #005293;
            font-size: 16px;
          }

          li > a:hover {
            color: #005293;
            text-decoration: none;
            background: #D9D9D9;;
          }

          &:after {
            content: '';
            display: block;
            width: 82px;
            height: 2px;
            background: #005293;
            border-radius: 1px;
            position: absolute;
            top: 0;
            left: 35px;
          }

          &.first-dropdown-menu {
            & > li {
              display: flex;
              a {
                width: 50%;
              }
            }
          }
        }

        &:hover .dropdown-menu {
          padding: 15px 0;
          height: auto;
        }

      }
    }

    .contact_us{
      padding: 8px 16px;
      color: #fff;
      font-size: 14px;
      border: 1px solid #fff;
      background: #005293;
      &:hover{
        background: #fff;
        color: #005293;
      }
    }
  }
</style>
